import axios from "../../axios-instance";
import {MILLISECONDS_IN_SECOND, SECONDS_IN_MINUTE} from "../constants";

const POLLING_DELAY_MS = 5000;
const POLLING_TIMEOUT = 30 * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
const STATUS_COMPLETED = 'COMPLETED';
const STATUS_FAILED = 'FAILED';

class ReportLoader {
  constructor(reportId) {
    this.reportId = reportId;
    this.stopLoad = false;
  }

  async processLoading(){
    const isReportReady = function (result) {
      const status = result.data.status;
      if (status === STATUS_FAILED) {
        throw new Error('Report generation failed');
      }
      return result.data.status === STATUS_COMPLETED;
    }

    const getReportStatus = function (reportId) {
      return axios.get(`/async_reports/executive_summary/report_status/${reportId}`);
    }

    const wait = function (delayMs) {
      return new Promise(resolve => {
        setTimeout(resolve, delayMs);
      });
    }

    const poll = async function (self, delayMs) {
      const reportId = self.reportId
      let result = await getReportStatus(reportId);
      let attempts = 1;
      while (!isReportReady(result)) {
        await wait(delayMs);
        if (self.stopLoad) {
          throw new Error('Report loading is canceled');
        }
        result = await getReportStatus(reportId);
        attempts++;
        if (attempts * delayMs >= POLLING_TIMEOUT) {
          throw new Error('Report loading is canceled by timeout');
        }
      }
      return result;
    }

    return poll(this, POLLING_DELAY_MS);
  }

  stopLoading() {
    this.stopLoad = true;
  }

}

export {ReportLoader};
